import React from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import { ListItem, ListItemSegment } from 'components/ListItem'
import { FlexContainer, FlexItem } from 'components/Flex'
import Icon from 'components/Icon'
import ContentLoading from 'components/ContentLoading'

import { match } from 'utils/patternMatchUtil'
import './styles.sass'

const CardItem = observer(function CardItem ({ card, disabled, onClick, onDeleteCardClick }) {
  return (
    <ListItem
      className={cx('card-item', disabled && 'payment-methods--item-disabled')}
      onClick={!disabled && onClick}
      clickable={!disabled}
      border
    >
      <ListItemSegment pad stretch>
        <div className="card-item__primary-info">
          <strong>{card.brand}</strong> ending in <strong>{card.last4}</strong>
        </div>
        <div className="card-item__secondary-info">
          <span className="card-item__expires">
            Expires <strong>{card.exp_month}/{card.exp_year}</strong>
          </span>
          &nbsp;
          &bull;
          &nbsp;
          <span className={cx('card-item__cvc', `card-item__cvc--${card.cvc_check}`)}>
            CVC check {match(card.cvc_check, {
              pass: 'passed',
              fail: 'failed',
              unavailable: 'unavailable',
              unchecked: 'unchecked',
              [match.DEFAULT]: 'unavailable'
            })}
          </span>
        </div>
      </ListItemSegment>
      <ListItemSegment pad>
        <FlexContainer>
          <FlexItem>
            {card.isDefaultSource &&
              <div className="card-item__default">
                Current Payment Method
              </div>
            }
          </FlexItem>
          {onDeleteCardClick && !disabled && !card.isDefaultSource &&
            <FlexItem>
              &nbsp;
              <button className="button is-icon-only" onClick={e => e.stopPropagation() || onDeleteCardClick()}>
                <Icon material name="delete" />
              </button>
            </FlexItem>
          }
        </FlexContainer>
      </ListItemSegment>
    </ListItem>
  )
})

export default observer(function PaymentMethods ({
  loading,
  busy,
  cards,
  onAddClick,
  onCardClick,
  onDeleteCardClick
}) {
  if (loading) {
    return <ContentLoading small />
  }
  return (
    <div className="payment-methods">
      {cards.map(card =>
        <CardItem
          disabled={busy}
          key={card.id}
          card={card}
          onClick={() => onCardClick(card)}
          onDeleteCardClick={onDeleteCardClick && cards.length > 1 && (() => onDeleteCardClick(card))}
        />
      )}
      <ListItem
        clickable={!busy}
        className={cx('payment-methods__add', busy && 'payment-methods--item-disabled')}
        onClick={!busy && onAddClick}
        border
      >
        <ListItemSegment stretch pad className="payment-methods__add-inner">
          <Icon material name="credit card" />
          &nbsp;
          Add Payment Method
        </ListItemSegment>
      </ListItem>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/client/components/PaymentMethods/index.jsx